// extracted by mini-css-extract-plugin
module.exports = {"container":"DateEvent_container__2I0vb","name":"DateEvent_name__1UaGb","date":"DateEvent_date__3mbLi"};